export default "<div class=\"popupMask\" @click=\"popupMaskClicked\">\n  <div class=\"popupWrapper\">\n    <slot></slot>\n  </div>\n</div>\n";